import { cn } from "@/lib/utils";

const CartIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
    className={cn("h-6 w-6", className)}
  >
    <path
      d="M2 3h2.2l2.3 12.1a1.6 1.6 0 0 0 1.57 1.3h9.06a1.6 1.6 0 0 0 1.57-1.27L20.4 7H5.4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="9" cy="20" r="1.25" fill="currentColor" />
    <circle cx="18" cy="20" r="1.25" fill="currentColor" />
  </svg>
);

export default CartIcon;
